module.exports = __webpack_public_path__ + "img/restaurant-default.38402851.jpg";